import { render, staticRenderFns } from "./favorites.vue?vue&type=template&id=915e1e3a&"
import script from "./favorites.vue?vue&type=script&lang=js&"
export * from "./favorites.vue?vue&type=script&lang=js&"
import style0 from "./favorites.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports